// extracted by mini-css-extract-plugin
export default {"inputBox":"InputCmp_inputBox__RYVAW","requiredAsterisk":"InputCmp_requiredAsterisk__Zc3ag"};